{
  "actions": "Actions",
  "hideButtonLabel": "Afficher moins",
  "noTags": "Aucun",
  "showAllButtonLabel": "Tout afficher ({tagCount, number})"
}
